import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect } from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';
class FatigueEffectivenessSearch extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      fields: [],
      range: [],
      start: '',
      finish: '',
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.search = this.search.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChangeData (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  // Setamos o state.date_start para a data de hoje
  componentWillMount () {
    var now = new Date();
    var month = now.getMonth()+1;
    var year = now.getFullYear();

    if (month < 10) {
      month = '0' + month;
    }
  
    var start = month + '/' + year;
    this.setState({start: start});
    this.setState({finish: start});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      start: this.state.start,
      finish: this.state.finish,
      applicability_id: this.state.applicability_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/formulario/mensal/estatisticas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({fields: responseJson.data.fields, range: responseJson.data.range});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/parametros-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({applicabilities_list: responseJson.data.applicabilities});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div>
    <div className="conteudo">
    
      <h3 className="page-title pull-left">{this.locale.Formularios.ProcurarFormulario.titulo}</h3>
      <Link to="/relatorios-de-fadiga/tripulante" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Formularios.ProcurarFormulario.formulario.Inicio}:</label>
              <InputMask value={this.state.start} required maskChar={null} name="start" mask="99/9999" className="form-control" onChange={this.handleChangeData.bind(this, 'start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Formularios.ProcurarFormulario.formulario.Termino}:</label>
              <InputMask value={this.state.finish} required maskChar={null} name="finish" mask="99/9999" className="form-control" onChange={this.handleChangeData.bind(this, 'finish')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Formularios.ProcurarFormulario.formulario.Aplicabilidade}:</label>
              <Select
                required
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.Formularios.ProcurarFormulario.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>

      <hr/>
      <h3 className="page-title">{this.locale.Formularios.ProcurarFormulario.tituloListaDeFormulariosDeEfetividade}</h3>
      <hr/>
      <table className="table">
        <thead>
          <tr>
            <th className="text-center">{this.locale.Formularios.ProcurarFormulario.tabela.Secao}</th>
            <th className="text-center">{this.locale.Formularios.ProcurarFormulario.tabela.Subsecao}</th>
            <th className="text-center">{this.locale.Formularios.ProcurarFormulario.tabela.Campo}</th>
            {this.state.range.map((item) => {
              return (
                <th className="text-center">{item}</th>
              );
            }
            )}
          </tr>
        </thead>
        <tbody id="effectiveness">
          {this.state.fields.map((item) => {
            return (
              <tr>
                <td className="text-center">{item.effectiveness_section_name}</td>
                <td className="text-center">{item.subsection_name}</td>
                <td className="text-center">{item.field_name}</td>
                {item.values.map((item) => {
                  return (
                    <td className="text-center">{item}</td>
                  );
                }
                )}
              </tr>
            );
          }
          )}
        </tbody>
      </table>

    </div>
  </div>
</div>
    );
  }
}

export default FatigueEffectivenessSearch;



// WEBPACK FOOTER //
// ./src/Components/FatigueEffectiveness/FatigueEffectivenessSearch.js